import { Reveal } from "./motion";
import { Button } from "./ui/button";
import { Phone, Mail, MapPin } from "lucide-react";
import { useConversion } from "../context/BookingContext";
import { BUSINESS } from "../data";

export default function Contact() {
  const { openBooking, openQuote } = useConversion();

  return (
    <section id="contact" data-testid="contact" className="bg-[#050505] py-20 md:py-32 border-t border-zinc-800">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-16">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-[#FF3B30] mb-4">Get started</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl md:text-6xl leading-none">
            Two ways to<br />start today.
          </h2>
          <p className="text-zinc-400 mt-6 max-w-md">
            Book a fixed-price service with a small deposit, or send photos of your vehicle and we'll quote your ceramic coating or paint correction — no obligation.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <Button data-testid="cta-book-service-contact" onClick={() => openBooking()} variant="outline" className="rounded-none border-white bg-transparent text-white hover:bg-white hover:text-black font-display uppercase tracking-widest h-13 py-4">
              Book a Service
            </Button>
            <Button data-testid="cta-get-quote-contact" onClick={() => openQuote()} className="rounded-none bg-[#FF3B30] hover:bg-[#D63026] text-white font-display uppercase tracking-widest h-13 py-4">
              Get a Coating Quote
            </Button>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="border border-zinc-800 divide-y divide-zinc-800">
            <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="contact-phone" className="flex items-center gap-4 p-6 hover:bg-[#0A0A0A] transition-colors group">
              <Phone className="text-[#FF3B30]" strokeWidth={1.5} />
              <div>
                <p className="text-zinc-500 text-xs uppercase tracking-widest">Call</p>
                <p className="font-display text-xl group-hover:text-[#FF3B30] transition-colors">{BUSINESS.phone}</p>
              </div>
            </a>
            <a href={`mailto:${BUSINESS.email}`} data-testid="contact-email" className="flex items-center gap-4 p-6 hover:bg-[#0A0A0A] transition-colors group">
              <Mail className="text-[#FF3B30]" strokeWidth={1.5} />
              <div>
                <p className="text-zinc-500 text-xs uppercase tracking-widest">Email</p>
                <p className="font-display text-lg break-all group-hover:text-[#FF3B30] transition-colors">{BUSINESS.email}</p>
              </div>
            </a>
            <div className="flex items-start gap-4 p-6">
              <MapPin className="text-[#FF3B30] mt-1" strokeWidth={1.5} />
              <div>
                <p className="text-zinc-500 text-xs uppercase tracking-widest">Service area</p>
                <p className="font-display text-lg">{BUSINESS.area}</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {BUSINESS.areasServed.map((a) => (
                    <span key={a} className="text-xs text-zinc-400 border border-zinc-800 px-2 py-1">{a}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
